import React, { useCallback, useEffect, useRef, useState } from "react";

import { HoldingsTableColumn } from "../../constants";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import { FartherTableBodyCell } from "@src/sharedComponents/Table/Components";

import FormCellTextField from "./FormCellTextField";

import styles from "./FormCellTextField.module.css";

interface Props {
  column: HoldingsTableColumn;
  defaultValue: string;
  isLoading?: boolean;
}

const FormRowCell: React.FC<Props> = ({ column, defaultValue, isLoading }) => {
  const { value, adornment, inputType } = column;
  const [showRealField, setShowRealField] = useState(false);
  const textFieldRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (showRealField) {
      textFieldRef.current?.focus();
    }
  }, [showRealField]);

  const handleOnMouseEnter = useCallback(() => {
    if (!showRealField) {
      setShowRealField(true);
    }
  }, [showRealField]);

  const startAdornment = adornment === "$" ? "$" : undefined;
  const endAdornment = adornment === "%" ? "%" : undefined;
  const maxLength = value === "percentOfAccount" ? 1000 : undefined;

  if (isLoading) {
    return (
      <FartherTableBodyCell className={styles.fixedCellHeight}>
        <Skeleton />
      </FartherTableBodyCell>
    );
  }

  return (
    <FartherTableBodyCell
      className={styles.fixedCellHeight}
      onClick={handleOnMouseEnter}
    >
      <FormCellTextField
        leftIcon={startAdornment}
        rightIcon={endAdornment}
        name={value}
        defaultValue={defaultValue}
        placeholder="--"
        maxLength={maxLength}
        inputType={inputType}
      />
    </FartherTableBodyCell>
  );
};

export default FormRowCell;
